<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/monitor")
          i.fa.fa-eye
          span.ml-1 {{ $t("ui.monitor") }}
      b-breadcrumb-item
        router-link(to="/match/cmdmatch")
          i.fa.fa-futbol
          span.ml-1 {{ $t("ui.cmd") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row(v-if="detailShow && matchInfo").animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $tc("ui.leagues", 1) }}
                    th(width=200)
                      span {{ $t("ui.home") }}
                    th(width=200)
                      span {{ $t("ui.away") }}
                    th(width=80)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th(width=80)
                      span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                    th(width=80)
                      span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                tbody
                  tr
                    td
                      span {{ matchInfo.match_id }}
                    td
                      span {{ matchInfo.sport_type }}
                    td
                      span(:title="matchInfo.league_name") {{ matchInfo.league_name }}
                    td
                      span(:title="matchInfo.home_team") {{ matchInfo.home_team }}
                    td
                      span(:title="matchInfo.away_team") {{ matchInfo.away_team }}
                    td.text-uppercase
                      span {{ matchInfo.market_type }}
                    td
                      span {{ $moment(matchInfo.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ matchInfo.match_time }}
          div.row(v-if="!detailShow")
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-trophy
                    DebounceInput(required type="text" v-model="leagueSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                  //- DateRangePicker(
                  //-   v-model="dateRange"
                  //-   :locale-data="locale"
                  //-   :autoApply="true"
                  //-   :showDropdowns="true"
                  //- )
                  //- div(slot="input" slot-scope="picker")
          div.row(v-if="!detailShow")
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.far.fa-clock
                    b-form-select(v-model="marketType")
                      option(value="") {{ $t('ui.all') }}
                      option(value="early") {{ $t('ui.early') }}
                      option(value="today") {{ $t('ui.today') }}
                      option(value="live") {{ $t("ui.live") }}
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-sort
                    b-form-select(v-model="sortKey")
                      option(value="match_id") {{ $t('ui.id') }}
                      option(value="sport_type") {{ $tc('ui.sports', 1) }}
                      option(value="league_name") {{ $t("ui.name") }}
                      option(value="match_date") {{ $t("ui.match_date") }}
                    b-form-select(v-model="sortType")
                      option(value="asc") {{ $t("ui.ascending") }}
                      option(value="desc") {{ $t("ui.descending") }}
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getCMDMatchList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div(v-if="!detailShow")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="cmdMatchTotalRow"
                  :per-page="getPageSize"
                  v-model="currentCMDMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
            div.row.clusterize
              div.col-md-12.clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th(width=100)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $tc("ui.leagues", 1) }}
                      th(width=200)
                        span {{ $t("ui.home") }}
                      th(width=200)
                        span {{ $t("ui.away") }}
                      th(width=80)
                        span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th(width=80)
                        span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                      //- th(width=100).text-center
                      //-   span {{ $t("ui.is_live") }}
                      th(width=80)
                        span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                      //- th(width=200)
                      //-   span {{ $t("ui.epoch_time") }}
                      th(width=80)
                        span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                      th(width=60)
                        span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                      th(width=60)
                        span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                      th(width=200)
                        span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                  tbody.clusterize-content
                    tr(v-if="cmdMatchList.length == 0")
                      td(colspan="12").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in cmdMatchList")
                      td
                        span
                          b-link.clickable(href="javascript:void(0);" @click="getOddsInfo(item)") {{ item.match_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      td.text-uppercase
                        span {{ item.market_type }}
                      td
                        span {{ getDate(item.match_date) }}
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check': item.is_live, 'fas fa-times': !item.is_live  }")
                      td
                        span {{ item.match_time }}
                      //- td
                      //-   span {{ item.epoch_time }}
                      td
                        span {{ item.match_link }}
                      td
                        span {{ item.running_score }}
                      td
                        span {{ item.running_time }}
                      td
                        span(:title="item.parent_league")  {{ item.parent_league }}
          div(v-if="detailShow")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="hideDetail()"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-3(v-if="groups")
              div.col
                b-form-radio-group(v-model="selectedGroup" :options="groupItems" buttons button-variant="outline-primary" size="sm" @change="resetLog")
            div.row.mb-5(v-if="selectedGroup").animated.fadeIn
              div.col
                div.row
                  div.col-md-6.clusterize
                    .clusterize-scroll
                      table.tablex(style="width: 100%; table-layout: auto;")
                        thead
                          tr
                            th.text-center(v-for="(v, k) in details[selectedGroup][0]")
                              span {{ k }}
                        tbody.clusterize-content
                          tr(v-for="item in details[selectedGroup]")
                            td.text-uppercase.text-center
                              span
                                b-link.clickable(href="javascript:void(0);" @click="getLogs(item)") {{ item["odds_id"] }}
                            td.text-uppercase.text-center(v-for="(v, k) in item" v-if="k != 'odds_id'" style="min-width: 40px;")
                              span {{ v }}
                  div(v-if="logs").col-md-6.clusterize.animated.fadeIn
                    div.clusterize-scroll(style="max-height: 300px;")
                      table.tablex(style="width: 100%; table-layout: auto;")
                        thead
                          tr
                            th.text-center(v-for="(v, k) in logs[0]")
                              span {{ k }}
                        tbody.clusterize-content
                          tr(v-for="(v, k) in logs")
                            td(v-for="(i, j) in v")
                              span.text-uppercase {{ i }}
            div.row.mb-1(v-if="logs && logs.length > 0").animated.fadeIn
              div.col
                div.row
                  div.d-flex.justify-content-center.align-items-center#chart
                    apexchart(type="line" height="350" width="1500" :options="options" :series="series")
    //- cmdmatchinfo(ref="cmdMatchInfo" @failed="handleFailed" :item="info")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

// import cmdmatchinfo from "@/components/match/cmdMatchInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    // cmdmatchinfo
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    cmdMatchList: [],
    currentCMDMatchPage: 1,
    cmdMatchTotalRow: 0,
    leagueSearch: "",
    marketType: "",
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: new Date(),
    endDate: new Date(),
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    // dateRange: {
    //   startDate: new Date(),
    //   endDate: new Date()
    // },
    // locale: {
    //   direction: "ltr",
    //   format: "YYYY-MM-DD",
    //   separator: " - ",
    //   weekLabel: "W",
    //   firstDay: 1
    // },
    detailShow: false,
    oddsInfo: null,
    logs: null,
    selectedGroup: null,
    series: [],
    options: {
      chart: {
        id: 'chart'
      },
      xaxis: {
        type: 'datetime',
        categories:[],
        title: {
          text: 'DateTime'
        }
      },
      yaxis: {
        title: {
          text: 'Odds'
        },
      }
    }
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    groupItems: function() {
      if (this.groups) {
        var list = [];
        for (var prop in this.groups) {
          list.push({
            text: this.groups[prop].bet_type + " (" + this.groups[prop].ot_count + ")",
            value: this.groups[prop].bet_type
          });
        }
        return list;
      } else {
        return null;
      }
    },
    groups() {
      if (this.oddsInfo) {
        return this.oddsInfo["Table"];
      } else {
        return null;
      }
    },
    details() {
      if (this.oddsInfo) {
        return this.oddsInfo;
      } else {
        return null;
      }
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.endDate = this.today;
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    resetLog() {
      this.logs = null;
      this.resetGraphData();
    },
    hideDetail() {
      this.detailShow = false;
      this.selectedGroup = null;
      this.info = null;
      this.logs = null;
      this.resetGraphData();
    },
    resetGraphData() {
      this.series = [],
      this.options = {
        chart: {
          stacked: false,
          zoom: {
            type: 'x',
            enabled: true
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          id: 'chart'
        },
        plotOptions: {
          line: {
            curve: 'smooth',
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
          style: 'full',
        },
        xaxis: {
          type: 'datetime',
          categories:[],
          title: {
            text: 'DateTime'
          }
        },
        yaxis: {
          title: {
            text: 'Odds'
          },
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function (val) {
              return val.toFixed(2)
            }
          },
          x: {
            format: "yyyy-MM-dd hh:mm:ss"
          }
        }
      }
    },
    getOddsInfo: function(item) {
      this.matchInfo = item;
      this.detailShow = true;
      this.getOddsDetailInfo(item);
      // this.$refs.cmdMatchInfo.$refs.cmdMatchInfoModal.show();
    },
    getOddsDetailInfo: function (val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      let url = config.cmdMatchOddsInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        page_id: config.accessRoles.cmdmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.oddsInfo = response.data.tbl_cmd_match_odds_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLogs(val) {
      if (!val) {
        return;
      }

      if (!val.odds_id) {
        return;
      }

      let url = config.cmdMatchOddsLogsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        group_id: this.selectedGroup,
        odds_id: val.odds_id,
        page_id: config.accessRoles.cmdmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                var n = response.data.tbl_cmd_match_odds_logs["Table"];
                var m = [];
                for (var i in n) {
                  var ep = n[i].epoch_time / 1000000;
                  n[i].timestamp = this.$moment(ep).format("YYYY-MM-DD hh:mm:ss.SSS A");
                  delete n[i].epoch_time;
                  delete n[i].row_id;
                  delete n[i].odds_id;
                  delete n[i].match_id;
                  delete n[i].ot;
                  m.push(n[i]);
                }
                this.logs = m;
                
                this.resetGraphData();

                for (var i = 0; i < this.logs.length; i++) {
                  if (this.logs[i].hasOwnProperty('timestamp')) {
                    this.options.xaxis.categories.push(this.$moment(this.logs[i]['timestamp']).format("YYYY-MM-DD hh:mm:ss"));
                  }
                }

                for (var prop in this.logs[0]) {
                  if (prop != 'timestamp' && prop != 'mt') {
                    var json = { name: prop, data:[] };
                    for (var i = 0; i < this.logs.length; i++) {
                      if (this.logs[i].hasOwnProperty(prop)) {
                        json.data.push(this.logs[i][prop]);
                      }
                    }
                    this.series.push(json);
                  }
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCMDMatchList: function(isSearch) {
      let url = config.cmdMatchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentCMDMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdmatch,
        sport_id: this.sportType,
        league_name: this.leagueSearch,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentCMDMatchPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cmdMatchList = response.data.tbl_cmd_match_list;
                this.cmdMatchTotalRow = this.cmdMatchList.length > 0 ? this.cmdMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentCMDMatchPage = 1;
      this.getCMDMatchList();
    },
    changedPage: function(pageNo) {
      this.currentCMDMatchPage = pageNo;
      this.getCMDMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>